import { defineStore } from 'pinia'
import { getAgentActivities } from '@/common/services/AgentActivityService'
import { type Activity } from '@/common/types/activity'
import { ref, computed } from 'vue'

export const useActivitiesStore = defineStore('activities', () => {
  const activitiesList = ref<Activity[]>([])

  const noActivityDefault = {
    name: 'assist.activities.no-activity',
    description: 'assist.activities.no-activity.description',
    blockAutomaticPush: false,
    active: true,
    order: 0,
  }

  const userCurrentActivity = ref<Activity>(noActivityDefault)

  async function fetchAgentActivities() {
    activitiesList.value = await getAgentActivities()
  }
  const getAgentAllowingPushActivitiesByAlphabeticalOrder = computed(() => {
    const allowingPushActivities = activitiesList.value?.filter((activity) => !activity.blockAutomaticPush)

    return sortByAlphabeticalOrder(allowingPushActivities)
  })

  const getAgentBlockingPushActivitiesByAlphabeticalOrder = computed(() => {
    const blockingActivities = activitiesList.value?.filter((activity) => activity.blockAutomaticPush)

    return sortByAlphabeticalOrder(blockingActivities)
  })

  const getAgentActivityById = computed(() => {
    return (id: UUID) => activitiesList.value.find((activity) => activity.id === id)
  })
  const sortByAlphabeticalOrder = (activities: Activity[]) => {
    return activities.sort((a, b) => a.name.localeCompare(b.name))
  }

  return {
    userCurrentActivity,
    activitiesList,
    fetchAgentActivities,
    getAgentActivityById,
    noActivityDefault,
    getAgentBlockingPushActivitiesByAlphabeticalOrder,
    getAgentAllowingPushActivitiesByAlphabeticalOrder,
  }
})
